import { AfterViewInit, ChangeDetectorRef, Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Directive({ selector: '[appResizeObserver]' })
export class ResizeObserverDirective implements OnInit, OnDestroy, AfterViewInit {

    @Input()
    enableResize: boolean = true;
    @Output()
    resized = new EventEmitter();

    private ro: ResizeObserver;
    private target: HTMLElement;
    readonly entriesMap = new WeakMap();


    constructor(private el: ElementRef, private ref: ChangeDetectorRef) { }

    ngOnInit(): void {
        this.target = this.el.nativeElement;
        this.entriesMap.set(this.target, this);
    }

    ngAfterViewInit(): void {
        this.ro = new ResizeObserver(entries => {
            if (this.enableResize) {
                for (const entry of entries) {
                    if (this.entriesMap.has(entry.target)) {
                        const comp = this.entriesMap.get(entry.target);
                        comp._resizeCallback(entry);
                    }
                }
            }
        });
        addEventListener('resize', () => {
            this.ref.detectChanges();
            const entry = { contentRect: { width: this.target.offsetWidth, height: this.target.offsetHeight } };
            this._resizeCallback(entry);
        });
        this.ro.observe(this.target);
    }

    _resizeCallback(entry: any | ResizeObserverEntry): void {
        this.resized.emit(entry);
    }

    ngOnDestroy(): void {
        this.ro.unobserve(this.target);
        this.ro.disconnect();
        this.entriesMap.delete(this.target);
    }

}
